export enum AffiliatePayoutError {
  PAYOUT_ALREADY_REQUESTED = 'PAYOUT_ALREADY_REQUESTED',
  MINIMUM_PAYOUT_THRESHOLD = 'MINIMUM_PAYOUT_THRESHOLD',
}
